import { render, staticRenderFns } from "./VehicleType.html?vue&type=template&id=6c8be086&"
import script from "./VehicleType.vue?vue&type=script&lang=js&"
export * from "./VehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports